import { Box, Divider, Typography } from '@mui/material'
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { TokenCategories } from '@shared/components/TokenCategories';
import { AppContainer } from '@shared/components/AppContainer';
import { useEffect } from 'react';
import { getCategoriesAction, tokenSelector } from '@store/slices/token.slice';
import { HotToken } from './components/HotToken';
import { RecommendedTokens } from './components/RecommendedTokens';
import { FeaturedTokens } from './components/FeaturedTokens';
import { RecentTokens } from './components/RecentTokens';

export const MarketPlace = () => {
    const tokenSlice = useAppSelector(tokenSelector);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (tokenSlice.categories.length == 0) {
            dispatch(getCategoriesAction())
        }
    }, [])

    return (
        <AppContainer>

            {/*<FeaturedTokens />*/}

            <TokenCategories categories={tokenSlice.categories} />

            {/*<Box mt={10}>
                <Typography gutterBottom variant="h5" component="div">
                    <strong>Recommended Membership NFT</strong>
                </Typography>
            </Box>
            <RecommendedTokens />*/}
           

            <Box my={3}>
                <Divider />
            </Box>

            {/*<Box my={3}>
                <Typography gutterBottom variant="h5" component="div">
                    <strong>Hot Membership NFT</strong>
                </Typography>
            </Box>
            <HotToken />
            <Box my={3}>
                <Divider />
            </Box>*/}
            <Box my={2}>
                <Typography gutterBottom variant="h5" component="div">
                    <strong>Recently Listed Memberships</strong>
                </Typography>
            </Box>
            <RecentTokens />
         
        </AppContainer>
    )
}
